import WalledContent from 'components/Common/WalledContent'
import React from 'react'

import LEOfferPriceDetails from './LEOfferPriceDetails'
import OfferTileLoggedInButtons from 'components/OfferList/OfferListTiles/Support/OfferTileLoggedInButtons'

interface Props {
  offer: App.Offer | App.OfferSummary
}

interface MappedProps {
}

const LEOfferPriceDetailsWrapper = ({ offer }: Props & MappedProps) => {
  const pkg = offer.lowestPricePackage
  if (!pkg) {
    return null
  }

  const wall = (
    <OfferTileLoggedInButtons
      showNewTileOverride
      signUpText="Sign up for free"
      align="right"
      fullWidth={false}
      discountLabelAlign="end"
    />
  )

  return (
    <WalledContent enforced={offer.walledGarden} wall={wall}>
      <LEOfferPriceDetails offer={offer} pkg={pkg} />
    </WalledContent>
  )
}

export default LEOfferPriceDetailsWrapper
